import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL hash
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate("/modelo/login", { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await fetch(`${API_URL}/api/auth/google/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          throw new Error("Auth failed");
        }

        const userData = await response.json();
        
        // Store session token
        localStorage.setItem("jglinks_session", userData.session_token);
        
        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        
        // Redirect based on profile status
        if (userData.has_profile) {
          navigate("/modelo/dashboard", { replace: true, state: { user: userData } });
        } else {
          // Need to complete profile (set username)
          navigate("/modelo/completar-perfil", { replace: true, state: { user: userData } });
        }
      } catch (error) {
        console.error("Auth error:", error);
        navigate("/modelo/login", { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/60">Iniciando sesión...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
